import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'aa-range-slider',
    templateUrl: './range-slider.component.html',
    styleUrls: [
        './range-slider.component.scss'
    ],
    standalone: false
})
export class RangeSliderComponent
{
    @Input() min: number = 0;
    @Input() max: number = 100;
    @Input() val: number = 50;
    @Input() step: number = 1;
    @Output() rangeChange: EventEmitter<number> = new EventEmitter<number>();

    onChange ($event: any): void
    {
        this.rangeChange.emit($event.srcElement.value);
    }
}
